import SmileSignup from "src/pages_/smile/signup";

export default SmileSignup;
